// CORRELATION widget — maps to data-provider/source/instructions/CORRELATION

/** Available series categories for correlation variables */
export type CorrelationSeriesType = 'price' | 'kpi' | 'technical';

/** All available series options for the dropdown */
export const CORRELATION_SERIES_OPTIONS: { value: CorrelationSeriesType; label: string }[] = [
  { value: 'price', label: 'Price' },
  { value: 'kpi', label: 'KPI' },
  { value: 'technical', label: 'Technical' },
];

/** Horizon presets in trading days */
export const CORRELATION_HORIZON_OPTIONS: { value: number; label: string }[] = [
  { value: 63, label: '3M' },
  { value: 126, label: '6M' },
  { value: 252, label: '1Y' },
  { value: 504, label: '2Y' },
  { value: 756, label: '3Y' },
  { value: 0, label: 'All' },
];

export interface CorrelationWidgetConfig {
  /** Series type for Variable A (default: 'price') */
  series_a?: CorrelationSeriesType;
  /** Series type for Variable B (default: 'price') */
  series_b?: CorrelationSeriesType;
  /** Entity override for Variable B — ticker (defaults to dashboard asset) */
  entity_b?: string;
  /** Number of trading days to display (0 = all available) */
  horizon?: number;
  /** Rolling correlation window in trading days (default: 60) */
  correlation_window?: number;
}

export interface CorrelationWidgetInstanceConfig extends CorrelationWidgetConfig {
  dataKey?: string;
}

// API response shape from POST /datasources/widgets → CORRELATION
export interface CorrelationData {
  ticker: string;
  compare_ticker: string | null;
  series_a_label: string;
  series_b_label: string;
  series_a: Array<{ date: string; value: number }> | null;
  series_b: Array<{ date: string; value: number }> | null;
  correlation_series: Array<{ date: string; correlation: number }> | null;
  overall_correlation: number | null;
}
